import {AppError} from "../../model/app-error";
import {MapFile} from "../../model/map-file";
import {Action, createReducer, on} from "@ngrx/store";
import {mapFilesActions} from "../actions";
import {FIBER_TYPE, LAND_TYPE, OIL_GAS_TYPE, POWER_TYPE, RAILROAD_TYPE} from "../../consts/file.constants";
import * as _ from "lodash";
import {State as mapConfigState} from "../reducers/map-config.reducer";

export interface State {
  mapFiles: MapFile[],
  fiberFiles: MapFile[],
  landFiles: MapFile[],
  powerFiles: MapFile[],
  railroadFiles: MapFile[],
  oilGasFiles: MapFile[],
  fileMetadata: any,
  error: AppError
}

export const initialState: State = {
  mapFiles: [],
  fiberFiles: [],
  landFiles: [],
  powerFiles: [],
  railroadFiles: [],
  oilGasFiles: [],
  fileMetadata: null,
  error: undefined,
}

const mapFilesReducer = createReducer(initialState,
  on(mapFilesActions.nukeStore, (state) => {
    return {
      ...initialState
    };
  }),
  on(mapFilesActions.loadFilesSuccess, (state, action) => {
    return {
      ...state,
      mapFiles: action.mapFiles,
      fiberFiles: action.mapFiles.filter(file => file.name?.toLowerCase().includes('fiber')),
      landFiles: action.mapFiles.filter(file => file.name?.toLowerCase().includes('land')),
      powerFiles: action.mapFiles.filter(file => file.name?.toLowerCase().includes('power')),
      railroadFiles: action.mapFiles.filter(file => file.name?.toLowerCase().includes('railroad')),
      oilGasFiles: action.mapFiles.filter(file => file.name?.toLowerCase().includes('oil') || file.name?.toLowerCase().includes('gas'))
    };
  }),
  on(mapFilesActions.fileToggle, (state, action) => {
    const mapFiles: MapFile[] = _.cloneDeep(state.mapFiles);
    const existingMapFile = mapFiles.find((mapFile: MapFile) => mapFile.id == action.mapFile.id);
    if (existingMapFile) {
      existingMapFile.fileAssets = action.mapFile.fileAssets;
    }
    return {
      ...state,
      mapFiles: mapFiles,
      fiberFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('fiber')),
      landFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('land')),
      powerFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('power')),
      railroadFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('railroad')),
      oilGasFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('oil') || file.name?.toLowerCase().includes('gas')),
    };
  }),
  on(mapFilesActions.reloadFiles, (state, action) => {
    const mapFiles: MapFile[] = _.cloneDeep(state.mapFiles);
    return {
      ...state,
      mapFiles: mapFiles,
      fiberFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('fiber')),
      landFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('land')),
      powerFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('power')),
      railroadFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('railroad')),
      oilGasFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('oil') || file.name?.toLowerCase().includes('gas')),
    };
  }),
  on(mapFilesActions.fileColorChanged, (state, action) => {
    const mapFiles: MapFile[] = _.cloneDeep(state.mapFiles);
    const existingMapFile = mapFiles.find((mapFile: MapFile) => mapFile.id == action.mapFile.id);
    if (existingMapFile) {
      existingMapFile.fileAssets = action.mapFile.fileAssets;
    }
    return {
      ...state,
      mapFiles: mapFiles,
      fiberFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('fiber')),
      landFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('land')),
      powerFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('power')),
      railroadFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('railroad')),
      oilGasFiles: mapFiles.filter(file => file.name?.toLowerCase().includes('oil') || file.name?.toLowerCase().includes('gas')),
    };
  }),
  on(mapFilesActions.getFileMetadataSuccess, (state, action) => {
    return {
      ...state,
      fileMetadata: action.metadata
    };
  })
);

export function reducer(state: State | undefined, action: Action): any {
  return mapFilesReducer(state, action);
}
